var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('common-title', {
    attrs: {
      "title": "聚合国内外主流广告平台",
      "backColor": "#fff",
      "padding": "100,0,0,0"
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('transition', {
    attrs: {
      "name": "tab-fade",
      "mode": "out-in"
    },
    on: {
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [_c('div', {
    key: _vm.activeIndex,
    staticClass: "tab-element"
  }, [_c('img', {
    staticClass: "flexs w-001 h-840",
    attrs: {
      "src": _vm.getImagePath(_vm.activeIndex)
    }
  }), _c('div', {
    staticClass: "flexs column al-fs w-378 absolute l-150 t-328"
  }, [_c('span', {
    staticClass: "fs-34 c-303650 f-700 margin-b-40"
  }, [_vm._v(_vm._s(_vm.tabsList[_vm.activeIndex].title))]), _c('span', {
    staticClass: "fs-22 c-6 text-l"
  }, [_vm._v(_vm._s(_vm.tabsList[_vm.activeIndex].content))])])])]), _c('ul', {
    staticClass: "flexs jc-sa al-c fs-28 w-001 h-110 back-f o-8 c-0 absolute t-0 l-0 pointer tab-navigation"
  }, _vm._l(_vm.tabsList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "flexs jc-c al-c h-110 w-001 tab-item",
      class: {
        'active-tab': _vm.activeIndex === index
      },
      on: {
        "mouseenter": function ($event) {
          return _vm.selectTab(index);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])]);
  }), 0)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };